var _ = require('underscore');
module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='	<div class="workspace-content single-column">\n		<h1>Your account</h1>\n		<div id="region-profile">Loading...</div>\n		<div id="region-account"></div>\n		<div id="region-mfa"></div>\n	</div>\n';
}
return __p;
};
